<div class="user-form">
  <div class="user-form__header">
    <h2 class="user-form__title color-topaz">
      {{ isEdit ? 'EDITAR PÁTIO' : 'ADICIONAR PÁTIO' }}
    </h2>
    <button
      type="button"
      class="user-form__close"
      aria-label="Fechar"
      (click)="close()"
    >
      <i class="fa-regular fa-xmark"></i>
    </button>
  </div>

  @if (form && formReady) {
    <form class="user-form__body" [formGroup]="form" (submit)="submit()">
      <div class="user-form__fields">
        <app-input
          label="Nome"
          formControlName="name"
          [required]="true"
          [errorMessage]="getFieldError('name')"
        />

        <app-input
          label="CEP"
          formControlName="zipCode"
          placeholder="00000-000"
          mask="00000-000"
          [dropSpecialCharacters]="false"
          [required]="true"
          [errorMessage]="getFieldError('zipCode')"
          (blurred)="getCEP()"
        />

        <app-input
          label="Endereço"
          formControlName="address"
          [required]="true"
          [errorMessage]="getFieldError('address')"
        />

        <app-input
          label="Número"
          formControlName="addressNumber"
          [required]="true"
          [errorMessage]="getFieldError('addressNumber')"
        />

        <app-input
          label="Complemento"
          formControlName="addressComplement"
        />

        <app-combobox
          label="Cidade"
          placeholder="Buscar cidade..."
          searchPlaceholder="Buscar cidade..."
          [options]="cityOptions"
          [filterLocally]="false"
          formControlName="cityId"
          [required]="true"
          [errorMessage]="getFieldError('cityId')"
          (searchChange)="onCitySearch($event)"
        />

        <app-combobox
          label="Marca da unidade"
          placeholder="Buscar marca..."
          searchPlaceholder="Buscar marca..."
          [options]="makeOptions"
          [filterLocally]="false"
          formControlName="makeId"
          (searchChange)="onMakeSearch($event)"
        />

        <app-input
          label="Divisão"
          formControlName="division"
        />

        @if (canManageRegionalAar()) {
          <app-combobox
            label="Regional Auto Arremate"
            placeholder="Selecione..."
            formControlName="regionalAarId"
            [options]="regionalOptions"
          />
        }

        <app-textarea
          label="Condição de venda"
          formControlName="sellingTerms"
          [rows]="6"
          helperText="Texto exibido ao comprador na página do veículo."
          class="w-100"
        />
      </div>

      <div class="user-form__footer">
        <div type="button" class="cancel-button color-cool-grey cursor-pointer" (click)="close()">
          CANCELAR
        </div>
        <button type="submit" class="btn btn-primary btn-pill">
          {{ isEdit ? 'Salvar' : 'Adicionar' }}
        </button>
      </div>
    </form>
  }
</div>
